import { ConservationMethodology, MIXED_METHODOLGY_PROJECTS } from '@/api/rest/resources/conservation';

import { useProject } from './useProject';

export const useNatureUnitVariant = () => {
  const project = useProject();

  if (project?.id && MIXED_METHODOLGY_PROJECTS.includes(project.id as (typeof MIXED_METHODOLGY_PROJECTS)[number])) {
    return ConservationMethodology.vnu;
  }

  return project?.natureUnitVariant;
};
